<div class="list-container">
    <ng-container *ngFor="let form of importFormArray.controls; let i = index">
        <div class="row" [formGroup]="form">

            <mat-form-field appearance="fill">
                <mat-label>{{ "app.model.cost.cost-type.label" | translate }}</mat-label>
                <mat-select formControlName="costTypeId">
                    <mat-option *ngFor="let costType of costTypes" [value]="costType.id">{{ costType.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>{{ "app.model.cost.cost-center.label" | translate }}</mat-label>
                <mat-select formControlName="costCenterId">
                    <mat-option *ngFor="let costCenter of costCenters" [value]="costCenter.id">{{ costCenter.name }}</mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>{{ "app.component.cost-center-cost.cost.label" | translate }}</mat-label>
                <input matInput
                       formControlName="costCt">
                <span matSuffix>€</span>
            </mat-form-field>

            <button mat-icon-button (click)="deleteRow(i)">
                <mat-icon>delete</mat-icon>
            </button>
        </div>
    </ng-container>
    <button mat-icon-button
            [disabled]="!importFormArray.valid"
            (click)="addRow()">
        <mat-icon>add</mat-icon>
    </button>
</div>
